/**
 * Returns an elements offset top relative to the entire document.
 *
 * @param {Element} element Element to get offset of.
 * @returns {Number}
 */
export default function offsetTopDocument(element) {
  return element.getBoundingClientRect().top
    + (document.documentElement.scrollTop || window.pageYOffset); // Browser support
}
